import * as React from 'react';

const MicrosoftIcon$2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#F35325",
        d: "M1 1h8.57v8.57H1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#81BC06",
        d: "M10.43 1H19v8.57h-8.57z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#05A6F0",
        d: "M1 10.43h8.57V19H1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFBA08",
        d: "M10.43 10.43H19V19h-8.57z"
    }));

export { MicrosoftIcon$2 as MicrosoftIcon };
//# sourceMappingURL=Microsoft.mjs.map
